<div class="swiper-container">
	<div class="swiper-wrapper">
		<div class="swiper-slide" *ngFor="let mastHead of mastHeads">
			<tile-item [dataItem]="mastHead" [srcUrl]="srcUrl" [classList]="'plate--slide'"></tile-item>
		</div>
	</div>
</div>
